import { createRouter, createWebHistory } from "vue-router";
import { adminRoutes } from "./admin";
import { userRoutes } from "./user";
import { setupGuard, setupI18Guard, setupTrackGuard } from "./guard";

const isClient = typeof window !== "undefined";

// 创建路由实例
const router = createRouter({
  history: isClient ? createWebHistory(import.meta.env.VITE_BASE_URL) : createWebHistory(), // SSR时不需要特殊处理
  routes: [...userRoutes, ...adminRoutes],
});

if (isClient) {
  setupGuard(router);
  setupI18Guard(router);
  setupTrackGuard(router);
}

export default router;
